<nav class="breadcrumb" aria-label="Breadcrumb">
  <ol>
    @for (segment of segments(); track segment.label; let last = $last) {
      <li>
        @if (segment.route && !last) {
          <a [routerLink]="segment.route" class="breadcrumb-link">{{ segment.label }}</a>
        } @else {
          <span class="breadcrumb-current">{{ segment.label }}</span>
        }
      </li>
      @if (!last) {
        <li class="breadcrumb-separator" aria-hidden="true">›</li>
      }
    }
  </ol>
</nav>
